import {httpGet} from "../../../utils/httpClient";

/**
 * @typedef {Object} DisplayPlaceType
 * @property {string} [displayName]
 * @property {string} [type]
 */

/**
 * Place item returned by hotel autocomplete API
 * @typedef {Object} HotelPlace
 * @property {string} [cityName]
 * @property {string} [countryName]
 * @property {DisplayPlaceType} [displayPlaceType]
 * @property {string} [fullName]
 * @property {string} [iataCode] // present for airports in mixed results
 * @property {boolean} [isMetro]
 * @property {number} [placeId]
 * @property {string} [primaryPlaceType]    {'city'|'airport'|'country'|'hotel'|'village'}
 * @property {string} [regionName]
 * @property {string} [Iata]
 * @property {string} [Name]
 * @property {string} [city]
 */

/**
 * Fetch places for the Hotel Search autocomplete.
 *
 * @param {string} value
 * @returns {Promise<HotelPlace[]>}
*/
export const getHotelsAutocomplete = (value) => {
  if (!value) {
    return Promise.resolve([]);
  }
  return httpGet(`/api/hotel/autocomplete?search=${value}`)
    .then((response) => {
      if (!response.ok) {
        return []; // req failed
      }
      return response.json();
    })
    .then((result) => {
      if (!result) {
        // empty response
        return [];
      }
      return result.results
        .map(mapAutocompleteResults);;
    })
};

const mapAutocompleteResults = (hotel) => ({
  cc: hotel.countryCode,
  n: hotel.name,
  t: hotel.primaryPlaceType, //for now, check why we need this
  p: hotel.places,
  k: hotel.entityKey,
  ...hotel,
});
